import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAtom } from 'jotai';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import lzSAuthRememberAtom from '@lz-atoms/Auth/remember';
import LzSApp from '@lz/app/App';
import useLzFApiCall, { useLzFParseLoggedInData } from '@lz/services/Api';
import { lzFShowSuccessMessage } from '@lz/services/Utils';
import LzXFullPagePublicForm from '@lz-layouts/FullPagePublicForm';

export interface LzPPageLogin {
  className?: string;
  style?: React.CSSProperties;
  bgImg?: string;
  hideForgotPasswordLink?: boolean;
  hideCreateAccountLink?: boolean;
}

const LzXPageLogin = (props: LzPPageLogin) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [authRememberState, setAuthRememberState] = useAtom(lzSAuthRememberAtom);

  const navigate = useNavigate();

  const apiCall = useLzFApiCall();
  const parseLoggedInData = useLzFParseLoggedInData();

  const onSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    const data = await apiCall('login', { username, wp: password, authRememberState }, 'post');

    // Validate data and save
    if (parseLoggedInData(data, authRememberState)) {
      console.log('REDIRECTING...');
      navigate('/', { replace: true }); // used replace to remove login from browser history and make it goto exit if back button is hit
      lzFShowSuccessMessage('logged in successfully! loading dashboard...');
    }
  };

  return (
    <LzXFullPagePublicForm
      heading="Login"
      onSubmit={onSubmit}
      bgImg={props.bgImg || LzSApp.login_bg_image}
      className={props.className}
      style={props.style}
    >

      <FormGroup row>
        <TextField fullWidth variant='outlined' label='Email as Username' value={username}
          onChange={(event) => setUsername(event.target.value)} />
      </FormGroup>

      <FormGroup row>
        <TextField fullWidth variant='outlined' type='password' label='Password'
          value={password} onChange={(event) => setPassword(event.target.value)} />
      </FormGroup>

      <FormGroup>
        <Grid container>
          <Grid size={{ xs: 6 }}>
            <FormControlLabel
              control={
                <Checkbox checked={authRememberState}
                  onChange={(event) =>
                    setAuthRememberState(event.target.checked)
                  }
                />
              }
              label='Remember me!'
            />
          </Grid>
          {!props.hideForgotPasswordLink && (
            <Grid size={{ xs: 6 }} style={{ textAlign: 'right', marginTop: 12 }}>
              <Link to={'/forgot-password'}>Forgot your password?</Link>
            </Grid>
          )}
        </Grid>
      </FormGroup>

      <FormGroup>
        <Grid container>
          <Grid size={{ xs: 6 }}>
            <Button type='submit' variant='contained' color='primary'>Sign-In</Button>
          </Grid>
          {!props.hideCreateAccountLink && (
            <Grid size={{ xs: 6 }} style={{ textAlign: 'right', marginTop: 12 }}>
              <Link to={'/register'}>Create an Account</Link>
            </Grid>
          )}
        </Grid>
      </FormGroup>

    </LzXFullPagePublicForm>
  );
};

export default LzXPageLogin;
